import { FALLBACK_LANG_OPTION, LANG_OPTIONS_MAP, TLang, getUserLanguage } from '@webtrader/core/i18n';
import { ELanguageQueryString, mapTLangToLangQuery } from '@webtrader/core/i18n/constants';

export const mapLanguageCodeToLabel = (lang: string): string | undefined => {
  return LANG_OPTIONS_MAP[lang as TLang]?.label;
};

export const getQueryLangFromTLang = (): ELanguageQueryString => {
  const { value: fallbackLangKey } = FALLBACK_LANG_OPTION;
  const currentTLang = getUserLanguage();
  return mapTLangToLangQuery[currentTLang ?? fallbackLangKey] ?? mapTLangToLangQuery[fallbackLangKey];
};
